import React, { Component } from 'react'
import { NavLink as Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Y from '../y18n'
const styles = theme => ({
  content: {
    maxWidth: '1200px',
    margin: 'auto',
    padding: '16px 24px',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 16px'
    }
  },
  themeLink: {
    color: `${theme.palette.primary.main}`,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: `${theme.palette.primary.dark}`
    }
  }
})
class FooterComponent extends Component {
  render () {
    const { classes, country } = this.props
    return (
      <footer>
        <div
          className={classes.content}
          style={{
            fontSize: '14px',
            textAlign: 'center',
            marginTop: '20px'
          }}
        >
          {country === 'Sweden'
            ? `Copyright © ${new Date().getFullYear()} Hylte Jakt & Lantman, All rights reserved.`
            : `Copyright © ${new Date().getFullYear()} HJL IT & Development AB, All rights reserved.`}
          <br />
          {country === 'Sweden'
            ? `Hylte Jakt & Lantman, Hantverksgatan 15, 314 34 Hyltebruk`
            : `HJL IT & Development AB, Hantverksgatan 15, 314 34 Hyltebruk, Sweden`}
          <br />
          {/*  Quickfix for Zendesk mail form */}
          <a
            href={`mailto:support@hyltesim${country === 'Finland' ? '.fi' : '.se'}?subject=Fråga om HylteSIM&body=Om du har ett konto på HylteSIM så var vänlig och ange den mailadress du använder:%0D%0A%0D%0A%0D%0AOm du har ett aktivt abonnemang och din fråga rör just detta abonnemang, fyll då i ditt IMSI nummer (det räcker med de 6 sista sifforna):%0D%0A%0D%0A%0D%0ABeskriv utförligt vad du behöver hjälp med:%0D%0A%0D%0A%0D%0A`}
            className={classes.themeLink}
          >
            {`support@hyltesim${country === 'Finland' ? '.fi' : '.se'}`}
          </a>
          <br />
          <br />
          <Link to={'/privacy-policy'} className={classes.themeLink}>{Y`Privacy Policy`}</Link>
          {' '}
          {' | '}
          {' '}
          <Link to={'/terms-and-conditions'} className={classes.themeLink}>{Y`Terms and conditions`}</Link>
        </div>
      </footer>
    )
  }
}

export default withStyles(styles)(FooterComponent)



// WEBPACK FOOTER //
// ./src/common/footer.js